var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionMarkNavy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99966 14.6667C11.6816 14.6667 14.6663 11.6819 14.6663 8.00003C14.6663 4.31814 11.6816 1.33337 7.99966 1.33337C4.31777 1.33337 1.33301 4.31814 1.33301 8.00003C1.33301 11.6819 4.31777 14.6667 7.99966 14.6667Z",
    stroke: "#425CC7",
    strokeWidth: 1.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48775 9.39748C7.48775 9.26927 7.47428 9.16671 7.47428 9.10261C7.47049 8.77043 7.5298 8.44034 7.64935 8.12825C7.74363 7.8976 7.88045 7.68485 8.05337 7.50004C8.27907 7.25789 8.52206 7.03086 8.78059 6.82055C9.04452 6.61875 9.27593 6.38118 9.46742 6.11543C9.57536 5.94067 9.63123 5.74122 9.62902 5.5385C9.62748 5.3517 9.58472 5.1673 9.50353 4.99724C9.42233 4.82718 9.3045 4.67525 9.15767 4.55132C9.00793 4.41301 8.83082 4.3044 8.63663 4.23177C8.44243 4.15914 8.23502 4.12395 8.02643 4.12825C7.62803 4.11589 7.24069 4.25417 6.94906 4.51286C6.65279 4.76927 6.46425 5.16671 6.36998 5.71799L5.33301 5.6026C5.42728 4.87184 5.71009 4.30773 6.16797 3.9103C6.62585 3.51286 7.24534 3.33337 8.01297 3.33337C8.78059 3.33337 9.46742 3.5385 9.93877 3.96158C10.169 4.1476 10.3535 4.37953 10.4792 4.64096C10.6049 4.90238 10.6686 5.18691 10.666 5.4744C10.6727 5.80688 10.5842 6.13482 10.4101 6.42312C10.2485 6.71799 9.91183 7.07696 9.42701 7.48722C9.19089 7.67603 8.97028 7.88176 8.76712 8.1026C8.66355 8.24116 8.59027 8.39811 8.55165 8.56414C8.48699 8.8376 8.45536 9.11719 8.45738 9.39748H7.48775ZM7.42041 12V10.8975H8.57859V12H7.42041Z",
    fill: "#425CC7",
    stroke: "#425CC7",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkNavy);
export default __webpack_public_path__ + "static/media/question_mark_navy.1e751d51.svg";
export { ForwardRef as ReactComponent };